module.exports = __webpack_public_path__ + "assets/img/Main material (15).027d20ef.jpg";